import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navItems = [{
    path: '/whats-wrong',
    label: "What's Wrong"
  }, {
    path: '/how-we-fix-it',
    label: 'How We Fix It'
  }, {
    path: '/where-ai-fits',
    label: 'Where AI Fits'
  }, {
    path: '/about-john',
    label: 'About John'
  }];
  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);
  return <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1D2A3A]/95 backdrop-blur-md border-b border-white/15" data-id="element-139">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-140">
          <Link to="/" className="group flex items-center gap-3" data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/pCtzMmZ2ci5LGu7D7o9MNa/GTH_Logo_(3).png" alt="Growth That Holds" className="h-8 w-auto" data-id="element-142" />
            <span className="text-xl font-serif font-semibold text-white" data-id="element-143">
              Growth That Holds
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-144">
            {navItems.map(item => <Link key={item.path} to={item.path} className={`relative text-sm font-medium transition-colors duration-200 ${location.pathname === item.path ? 'text-white' : 'text-white/80 hover:text-white'}`} data-id="element-145">
                {item.label}
                {location.pathname === item.path && <motion.div layoutId="activeNav" className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#D4A674]" transition={{
              type: 'spring',
              stiffness: 380,
              damping: 30
            }} data-id="element-146" />}
              </Link>)}
          </div>

          <Link to="/honest-conversation" className="hidden md:block px-6 py-2 bg-transparent text-sm font-medium border border-white text-white hover:bg-white hover:text-[#1D2A3A] transition-all duration-200" data-id="element-147">
            Book an Honest Conversation
          </Link>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-white" aria-label="Toggle menu" data-id="element-148">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-149" /> : <Menu className="w-6 h-6" data-id="element-150" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-151">
        {mobileMenuOpen && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="fixed inset-0 bg-[#1D2A3A]/40 backdrop-blur-sm z-40 md:hidden" onClick={() => setMobileMenuOpen(false)} data-id="element-152" />

            {/* Menu Panel */}
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 30,
          stiffness: 300
        }} className="fixed top-[73px] right-0 bottom-0 w-full max-w-sm bg-[#1A2838] border-l border-white/15 z-40 md:hidden overflow-y-auto" data-id="element-153">
              <div className="p-6 space-y-6" data-id="element-154">
                {/* Navigation Links */}
                <div className="space-y-4" data-id="element-155">
                  {navItems.map((item, index) => <motion.div key={item.path} initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: index * 0.1
              }} data-id="element-156">
                      <Link to={item.path} className={`block w-full text-left py-3 px-4 text-lg font-medium transition-colors duration-300 ${location.pathname === item.path ? 'text-white bg-white/10 border-l-2 border-[#D4A674]' : 'text-white/80 hover:text-white hover:bg-white/10'}`} data-id="element-157">
                        {item.label}
                      </Link>
                    </motion.div>)}
                </div>

                {/* CTA Button */}
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: navItems.length * 0.1
            }} className="pt-6 border-t border-white/15" data-id="element-158">
                  <Link to="/honest-conversation" className="block w-full px-6 py-4 bg-transparent border border-white text-white hover:bg-white hover:text-[#1A2838] text-base font-medium transition-all duration-200 text-center" data-id="element-159">
                    Book an Honest Conversation
                  </Link>
                </motion.div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}